var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('stacked-area-score',{attrs:{"title":this.title,"scoreAreaComparativeList":_vm.getData,"cropType":_vm.cropType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }